import { isLoadingSelector, isUpdatedSelector, errorSelector } from '../utils/helperSelectors';
const reducerName = 'shortlink';
export const shortlinkSelector = (state) => state.shortlink.data || '';
export const isShortlinkLoadingSelector = isLoadingSelector(reducerName);
export const isShortlinkUpdatedSelector = isUpdatedSelector(reducerName);
export const shortlinkErrorSelector = errorSelector(reducerName);
//# sourceMappingURL=selectors.js.map